module.exports = __webpack_public_path__ + "static/media/Casino-caliente-banner.9f8c3da8.jpg";